import { render, staticRenderFns } from "./OrderStatusCompletedIcon.vue?vue&type=template&id=2ecb3156&scoped=true&"
import script from "./OrderStatusCompletedIcon.vue?vue&type=script&lang=js&"
export * from "./OrderStatusCompletedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecb3156",
  null
  
)

export default component.exports